import { Injectable, inject } from '@angular/core';
import { LoggerService } from '@pf/shared-services';
import {
    AbstractTypeEntityFacade,
    TypeEntityStore,
} from '@pf/shared/util-platform';
import { ServicesService } from '@control-tower/platform-transportation';
import { TypeEntityTypes } from '@pf/shared-common';

@Injectable()
export class ServiceFacade extends AbstractTypeEntityFacade<ServicesService> {
    constructor() {
        const typeService = inject(ServicesService);
        const store = inject(TypeEntityStore);
        const logger = inject(LoggerService);

        super(
            store,
            logger,
            typeService,
            'serviceGetAll',
            TypeEntityTypes.Service
        );
    }
}
